export default "__VITE_ASSET__cb2d262f__"